import {
  DateTimeValue,
  FieldType,
  FormNode,
  LookupValue,
  OptionsetFieldDefinition,
  OptionsetValue,
  StringValue,
} from '@msdk/definitions'
import React, { ReactNode } from 'react'

import { AttachmentFieldRenderer } from './AttachmentFieldRenderer'
import { DateTimeFieldRenderer } from './DateTimeFieldRenderer'
import { LookupFieldRenderer } from './LookupFieldRenderer'
import { OptionSetFieldRenderer } from './OptionSetFieldRenderer'
import { StringFieldRenderer } from './StringFieldRenderer'

interface Props {
  fieldType: FieldType
  node: FormNode
  stringValue?: string
}

export const ConditionalFormFieldRenderer = ({ fieldType, node }: Props) => {
  const renderer: Record<FieldType, ReactNode> = {
    Attachment: <AttachmentFieldRenderer node={node} />,
    Bag: null,
    Custom: null,
    DateTime: <DateTimeFieldRenderer value={node.value.data as DateTimeValue} />,
    Duration: null,
    Image: null,
    List: null,
    Lookup: <LookupFieldRenderer value={node.value.data as LookupValue} />,
    MetadataSelector: null,
    MultiSelector: null,
    Numeric: null,
    OptionSet: (
      <OptionSetFieldRenderer
        value={node.value.data as OptionsetValue}
        fieldDef={node.value.fieldDefinition as OptionsetFieldDefinition}
      />
    ),
    String: <StringFieldRenderer value={node.value.data as StringValue} />,
  }
  return <>{renderer[fieldType]}</>
}
